/**
 *  BlockSpacer script file
**/

export default {
  name: 'BlockSpacer',
  mixins: [],
  components: {},
  props: {
    text: {
      type: String,
      required: true
    },
    help: {
      type: Object,
      required: false
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
